// extracted by mini-css-extract-plugin
module.exports = {"table":"actions-history-modal_table__PILsF","container":"actions-history-modal_container__13DkM","modal":"actions-history-modal_modal__35zPY"};